export default "__VITE_ASSET__Cl$gFilH__"